import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/value-stories')({
  component: () => <Outlet />,
})
